import { getCustomer, SUPPORTED_CUSTOMERS } from "../components/MainPage/VersionInfo";

export const JourneyPlanHelper = {
  getMaintenanceClosedBy: (journeyPlans) => {
    let closedBy = null;
    let closeDate = null;
    if (!journeyPlans) return closedBy;
    for (let journeyPlan of journeyPlans) {
      if (journeyPlan) {
        const task = journeyPlan.tasks && journeyPlan.tasks[0];
        let findClose = task.maintenance.find((m) => m.endDateTime);
        if (findClose && (closeDate ? findClose.endDateTime < closeDate : true)) {
          closeDate = findClose.endDateTime;
          closedBy = journeyPlan.user.name;
        }
      }
    }
    return closedBy;
  },
  getExecutionClose: (journeyPlan) => {
    let closedBy = null;
    if (journeyPlan) {
      const task = journeyPlan.tasks && journeyPlan.tasks[0];
      let findClose = task.maintenance.find((m) => m.endDateTime);
      if (findClose) {
        closedBy = journeyPlan.user.name;
      }
    }
    return closedBy;
  },
};



// WEBPACK FOOTER //
// ./src/utils/journeyPlanHelper.js